import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const CONSENT_KEY = 'atlas-cookie-consent';

function initAnalytics() {
  if (window.posthog && typeof window.posthog.init === 'function') {
    window.posthog.init('phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs', {
      api_host: 'https://us.i.posthog.com',
      person_profiles: 'identified_only',
      session_recording: {
        recordCrossOriginIframes: true,
        capturePerformance: false,
      },
    });
  }
}

export function resetCookieConsent() {
  localStorage.removeItem(CONSENT_KEY);
}

// UK PECR/GDPR consent banner. Analytics (PostHog) loads only after "Accept".
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(CONSENT_KEY);
    if (choice === 'accepted') initAnalytics();
    else if (!choice) setVisible(true);
  }, []);

  const decide = (accepted) => {
    localStorage.setItem(CONSENT_KEY, accepted ? 'accepted' : 'declined');
    setVisible(false);
    if (accepted) initAnalytics();
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-4" role="dialog" aria-label="Cookie consent">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-200 p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center shrink-0">
          <Cookie size={20} className="text-[#0f2b4a]" />
        </div>
        <div className="flex-1">
          <p className="text-sm text-gray-700 leading-relaxed">
            We use optional analytics cookies to understand how our site is used and improve it. We only set
            them if you accept. See our{' '}
            <Link to="/cookie-policy" className="text-blue-700 underline">Cookie Policy</Link> for details.
          </p>
        </div>
        <div className="flex gap-2 shrink-0 w-full sm:w-auto">
          <button
            onClick={() => decide(false)}
            className="flex-1 sm:flex-none border border-gray-300 text-gray-700 hover:bg-gray-50 px-4 py-2 rounded-lg text-sm font-semibold transition-colors"
          >
            Decline
          </button>
          <button
            onClick={() => decide(true)}
            className="flex-1 sm:flex-none bg-[#0f2b4a] hover:bg-[#1565c0] text-white px-5 py-2 rounded-lg text-sm font-semibold transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
